import svg4everybody from 'svg4everybody';
import 'lite-youtube-embed';
import 'lite-vimeo-embed';

export default function() {
    svg4everybody();
}
